
import { Crumbs } from "molecules/Breadcrumbs";
import { TitleHeading } from "molecules/TitleHeading";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { ListBox } from "primereact/listbox";
import { Timeline } from "primereact/timeline";
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { FaMapMarkerAlt, FaClock } from "react-icons/fa";
import { useSelector } from "react-redux";
import { FiBriefcase } from "react-icons/fi"; // For the job icon
import "./Job.css";
import { useNavigate, useParams } from "react-router-dom";
import { SmallHadding } from "molecules/SmallHeadding";
import { fetchJobById, submitJobApplication } from "../../api";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
const CustDropdown = styled(MultiSelect)`
  border: 1px solid rgb(200, 32, 39);
  background: transparent;
  border-radius: 0;
  font-weight: 500;
`;


const JobDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const { data: ourServiceData, loading: loadingourService, error: errorourService } = useSelector((state) => state.jobData);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Fetch job by ID
  useEffect(() => {
    const loadJob = async () => {
      if (!id) return;
      
      setLoading(true);
      setError(null);
      try {
        const jobData = await fetchJobById(id);
        setJob(jobData);
      } catch (err) {
        setError(err.message || "Failed to load job details");
        console.error("Error fetching job:", err);
      } finally {
        setLoading(false);
      }
    };
    
    loadJob();
  }, [id]);

  const [jobs, setJobs] = useState(null);
  const [showFullDesc, setShowFullDesc] = useState(false);
  

  useEffect(() => {
    if (Array.isArray(ourServiceData)) {
      setJobs(ourServiceData);
    } else {
      setJobs([]);
    }
  }, [ourServiceData]);

  const [selectedStrategies, setSelectedStrategies] = useState(null);
  const [showApplyDialog, setShowApplyDialog] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [resumeFile, setResumeFile] = useState(null);
  const toast = useRef(null);
  const [applicationForm, setApplicationForm] = useState({
    name: "",
    email: "",
    mobile: "",
    date_of_birth: "",
    years_of_experience: "",
  });

  const handleApplicationChange = (e) => {
    const { name, value } = e.target;
    setApplicationForm((prev) => ({ ...prev, [name]: value }));
  };

  const resetApplicationForm = () => {
    setApplicationForm({
      name: "",
      email: "",
      mobile: "",
      date_of_birth: "",
      years_of_experience: "",
    });
    setResumeFile(null);
  };

  const handleApplySubmit = async (e) => {
    e.preventDefault();
    if (!job?.id) return;

    if (
      !applicationForm.name ||
      !applicationForm.email ||
      !applicationForm.mobile ||
      !applicationForm.date_of_birth ||
      applicationForm.years_of_experience === "" ||
      !resumeFile
    ) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing fields",
        detail: "Please fill all fields and upload your resume.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("job_id", job.id);
    formData.append("job_title", job.title || "");
    formData.append("name", applicationForm.name);
    formData.append("email", applicationForm.email);
    formData.append("mobile", applicationForm.mobile);
    formData.append("date_of_birth", applicationForm.date_of_birth);
    formData.append("years_of_experience", applicationForm.years_of_experience);
    formData.append("resume", resumeFile);

    setSubmitting(true);
    try {
      await submitJobApplication(formData);
      toast.current?.show({
        severity: "success",
        summary: "Application submitted",
        detail: "Thank you for applying. We will get back to you soon.",
      });
      setShowApplyDialog(false);
      resetApplicationForm();
    } catch (err) {
      toast.current?.show({
        severity: "error",
        summary: "Submission failed",
        detail: err.message || "Something went wrong. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  // const strategies = [
  //   { name: "Real Assets", code: "RA" },
  //   { name: "Retirement Solutions", code: "RS" },
  //   { name: "Equity", code: "EQ" },
  //   { name: "Credit", code: "CR" },
  //   { name: "Financial Services", code: "FS" },
  //   { name: "Secondaries", code: "SE" },
  // ];

  // const jobs = [
  //   {
  //     title: "Analyst, Trade Support / Junior Trader...",
  //     location: "New York, New York",
  //     role_name: "R240482 Spotlight Job",
  //     date: "15 / May / 2024",
  //   },
  //   {
  //     title: "Analyst, Trade Support / Junior Trader...",
  //     location: "New York, New York",
  //     role_name: "R240482 Spotlight Job",
  //     date: "15 / May / 2024",
  //   },
  //   {
  //     title: "Analyst, Trade Support / Junior Trader...",
  //     location: "New York, New York",
  //     role_name: "R240482 Spotlight Job",
  //     date: "15 / May / 2024",
  //   },
  //   {
  //     title: "Analyst, Trade Support / Junior Trader...",
  //     location: "New York, New York",
  //     role_name: "R240482 Spotlight Job",
  //     date: "15 / May / 2024",
  //   },
  // ];

  return (
    <div className="backgroundThm mobileContainer">
      <Toast ref={toast} />
     
      <section>
        <div className="container px-0" style={{ marginLeft: "" }}>
        <Crumbs />
          <div className="grid section-title">
            <div className="lg:col-4 md:col-3 sm:col-12">
              {/* <TitleHeading title="Job Details" className="mt-0 mb-1" /> */}
              {/* <SmallHadding
            text="Job Search"
            className="mt-2 mb-2 ef-gamon-font" 
            
            
          /> */}
           <h3 className="pageTitle pb-2 mt-2.5" >Job Search</h3>
            </div>
          </div>

          <div class="grid nested-grid" style={{ marginLeft: "50px" }}>
          <div className="container mb-2">
          <div className="row careerWidthContainer ">
            <div class=" careerWidth  pr-0">
              <div class="text-left   pl-0 pr-3 pb-4 pt-4 font-bold text-500 border-right-none font17">
                {jobs?.length} Jobs Found
              </div>

              {jobs &&
                jobs.map((jobItem) => {
                  return (
                    <div
                      key={jobItem?.id}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate(`/job-details/${jobItem?.id}`);
                      }}
                      class="text-left pl-0 pr-3 pt-4 pb-4 border-1 border-right-none border-left-none font17 border-bottom-none"
                    >
                      <p className="m-0 font-bold">{jobItem?.title}</p>
                      <div className="flex align-items-center text-600">
                        <i className="pi pi-map-marker mr-2"></i>
                        <span>{jobItem?.location}</span>
                      </div>
                      <p className="mt-0 mb-0" style={{ color: "#0D0D0D80" }}>
                        {jobItem?.the_role || jobItem?.role_name}
                        <span className="text-sm" style={{ float: "right" }}>
                          {jobItem?.start_date ? new Date(jobItem.start_date).toLocaleDateString() : jobItem?.date}
                        </span>
                      </p>
                    </div>
                  );
                })}
            </div>
            <div class=" careerWidth mb-3 jubDetailsBorderLeft" style={{ marginRight: "" }}>
              <div class="text-left  h-full">
                <div 
                className="buttonCollection"
                  style={{
                   
                  }}
                >
                  <p
                  className="jobDetailHead"
                    style={{
                      fontFamily: "EB Garamond",
                      
                    }}
                  >
                    {job?.title || "Loading..."}
                  </p>
                  
                </div>
                <div className=" jobDetailsButton"
                  style={{
                   
                  }}
                >
                  <Button
                    outlined
                    className="py-1 px-3 text-xs mt-4 border-700 bg-white text-600"
                    onClick={() => setShowApplyDialog(true)}
                    disabled={!job}
                  >
                    Apply
                  </Button>

                  <div className="font17" >
                    {" "}
                    <FiBriefcase
                      //   style={{ marginTop: "0px" }}
                      className="icon"
                    />
                    <span style={{ fontWeight: 900 }}>{job?.designation || "N/A"}</span>
                  </div>
                </div>
                <div
                  style={{
                    backgroundColor: "#C82027",
                    height: "1px",
                    width: "100%",
                    marginTop: "24px",
                  }}
                ></div>
                <div className="job-details-container jobDetailsButton ">
                  <div className="job-info">
                    <div className="job-detail">
                      <FaMapMarkerAlt className="icon" />
                      <span style={{ fontSize: "17px" }}>
                        {job?.location || "N/A"}
                      </span>
                    </div>
                    <div className="job-detail">
                      <FiBriefcase className="icon" />
                      <span style={{ fontSize: "17px" ,fontWeight: 900}}>{job?.job_type || job?.designation || "N/A"}</span>
                    </div>
                    <div className="job-detail">
                      <FaClock className="icon" />
                      <span style={{ fontSize: "17px" }}>
                        {job?.start_date ? new Date(job.start_date).toLocaleDateString() : "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    backgroundColor: "#C82027",
                    height: "1px",
                    width: "100%",
                    marginTop: "20px",
                  }}
                ></div>
                <div className="container pl-0">
                {loading ? (
                  <div className="p-3">
                    <p className="font17">Loading job details...</p>
                  </div>
                ) : error ? (
                  <div className="p-3">
                    <p className="font17 text-red-500">Error: {error}</p>
                  </div>
                ) : !job ? (
                  <div className="p-3">
                    <p className="font17">Job not found</p>
                  </div>
                ) : (
                  <>
                    {job.position_overview && (
                      <div className="p-3 border-1 border-top-none border-right-none border-bottom-none border-left-none borderCustom">
                        <p className="jobTitleSection font17">Position Overview</p>
                        <p className="jobTitleSectionSub font17" dangerouslySetInnerHTML={{ __html: job.position_overview }} />
                      </div>
                    )}
                    {job.the_role && (
                      <div className="p-3 border-1 border-top-none border-right-none border-bottom-none border-left-none borderCustom">
                        <p className="jobTitleSection font17">The Role</p>
                        <p className="jobTitleSectionSub font17" dangerouslySetInnerHTML={{ __html: job.the_role }} />
                      </div>
                    )}
                    {job.primary_responsibilities && (
                      <div className="p-3 border-1 border-top-none border-right-none border-bottom-none border-left-none borderCustom">
                        <p className="jobTitleSection font17">Primary Responsibilities</p>
                        <p className="jobTitleSectionSub font17" dangerouslySetInnerHTML={{ __html: job.primary_responsibilities }} />
                      </div>
                    )}
                    {job.pay_range && (
                      <div className="p-3 border-1 border-top-none border-right-none border-bottom-none border-left-none borderCustom">
                        <p className="jobTitleSection font17">Pay Range</p>
                        <p className="jobTitleSectionSub payScale font17">
                          {job.pay_range}
                        </p>
                      </div>
                    )}
                    {job.qualification_experience && (
                      <div className="p-3 border-1 border-top-none border-right-none border-bottom-none border-left-none borderCustom">
                        <p className="jobTitleSection font17">Qualification & Experience</p>
                        <p className="jobTitleSectionSub font17" dangerouslySetInnerHTML={{ __html: job.qualification_experience }} />
                      </div>
                    )}
                    {job.about_quantum && (
                      <div className="p-3 border-1 border-top-none border-right-none border-bottom-none border-left-none borderCustom">
                        <p className="jobTitleSection font17">About Quantum</p>
                        <p className="jobTitleSectionSub font17" dangerouslySetInnerHTML={{ __html: job.about_quantum }} />
                      </div>
                    )}
                    {job.our_benefits && (
                      <div className="p-3 border-1 border-top-none border-right-none border-bottom-none border-left-none borderCustom">
                        <p className="jobTitleSection font17">Our Benefits</p>
                        <div className="jobTitleSectionSub font17" dangerouslySetInnerHTML={{ __html: job.our_benefits }} />
                      </div>
                    )}
                  </>
                )}
                </div>
              </div>
            </div>
            </div>
              </div>
          </div>
        </div>
      </section>

      <Dialog
        header={`Apply for ${job?.title || "Job"}`}
        visible={showApplyDialog}
        style={{ width: "90vw", maxWidth: "520px" }}
        onHide={() => {
          if (!submitting) {
            setShowApplyDialog(false);
            resetApplicationForm();
          }
        }}
        draggable={false}
      >
        <form onSubmit={handleApplySubmit} className="flex flex-column gap-3">
          <div className="flex flex-column gap-1">
            <label htmlFor="name">Full Name</label>
            <InputText
              id="name"
              name="name"
              value={applicationForm.name}
              onChange={handleApplicationChange}
              required
            />
          </div>
          <div className="flex flex-column gap-1">
            <label htmlFor="email">Email</label>
            <InputText
              id="email"
              name="email"
              type="email"
              value={applicationForm.email}
              onChange={handleApplicationChange}
              required
            />
          </div>
          <div className="flex flex-column gap-1">
            <label htmlFor="mobile">Mobile</label>
            <InputText
              id="mobile"
              name="mobile"
              value={applicationForm.mobile}
              onChange={handleApplicationChange}
              required
            />
          </div>
          <div className="flex flex-column gap-1">
            <label htmlFor="date_of_birth">Date of Birth</label>
            <InputText
              id="date_of_birth"
              name="date_of_birth"
              type="date"
              value={applicationForm.date_of_birth}
              onChange={handleApplicationChange}
              required
            />
          </div>
          <div className="flex flex-column gap-1">
            <label htmlFor="years_of_experience">Years of Experience</label>
            <InputText
              id="years_of_experience"
              name="years_of_experience"
              type="number"
              min="0"
              step="0.5"
              value={applicationForm.years_of_experience}
              onChange={handleApplicationChange}
              required
            />
          </div>
          <div className="flex flex-column gap-1">
            <label htmlFor="resume">Resume (PDF, DOC, DOCX)</label>
            <input
              id="resume"
              type="file"
              accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              onChange={(e) => setResumeFile(e.target.files?.[0] || null)}
              required
            />
          </div>
          <Button
            type="submit"
            label={submitting ? "Submitting..." : "Submit Application"}
            disabled={submitting}
            className="mt-2 bg-red-500 text-white" 
          />
        </form>
      </Dialog>
    </div>
  );
};

export default JobDetails;
